import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearch } from 'hooks/useSearch'
import AddIcon from "@mui/icons-material/Add";
import { 
  deleteContract,
  createNewContract,
  editContract
} from 'redux/actions/contractsCatalog/contractsCatalogActions'
import Datetime from 'react-datetime'
import dayjs from 'dayjs'
import { ContractVariantAccordion } from './ContractVariantAccordion'
import { generateRandomID } from 'helpers/generateRandomID'
import { prePayrollBasePaymentPeriods } from './values'

const blue = '#0055aa'

export const FormContractEdit = (props) => {
  const { handleClose } = props
  const { contractSelected, addMode, deleteMode, station: stationSelected } = useSelector(state => state.contractsCatalog)
  const { stationsList } = useSelector(state => state.companies);
  const { setSnackbar } = useSearch();
  const [variants, setVariants] = useState([{ id: generateRandomID(32), name: "Nueva Variante", isComplete: 'bad' }])
  const [newVariants, setNewVariants] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const { token } = useSelector(state => state.login)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    name: '',
    idStation: '', 
    periodCalc: ''
  })
  const { name, idStation, periodCalc } = inputValues
  const dispatch = useDispatch()

  const handleSubmit = () => {
    if(deleteMode){
      dispatch(deleteContract(contractSelected.id, token))
      handleClose()
      return
    } 

    if(!(variants.filter(variant => variant.isComplete === 'bad').length || newVariants) 
    || (name && startDate && endDate && idStation && periodCalc)) {
      if (startDate > endDate) {
        setSnackbar("Fecha de inicio es mayor a la de expiración");
        return
      }
  
      const newValues = {
        ...contractSelected,
        name,
        startDate: startDate,
        endDate: endDate,
        idStation,
        periodCalc,
        variants: variants.map(variant => ({
          unitType: variant.unitType,
          job: variant.job,
          prePayrollBaseCalc: variant.prePayrollBaseCalc,
          homologation: variant.homologation,
          rules: variant.rules,
          tabulatorUse: variant.tabulatorUse
        }))
      }

      if(addMode){
        dispatch(createNewContract(newValues, token))
        handleClose()
      } else {
        dispatch(editContract(contractSelected.id, newValues, token))
        handleClose()
      }
    }
  }

  useEffect(() => {
    if (stationSelected?.id) {
      handleNewValues({
        idStation: stationSelected.id
      })
    }
    if (contractSelected) {
      handleNewValues({
        name: contractSelected.name,
        idStation: contractSelected.idStation,
        periodCalc: contractSelected.periodCalc
      })
      setStartDate(contractSelected.startDate)
      setEndDate(contractSelected.endDate)
      setVariants(contractSelected.variants.map(variant => ({...variant, name: `${variant.job} ${variant.unitType}`, isComplete: 'good'})))
    }
    // eslint-disable-next-line 
  }, [contractSelected, stationSelected])

  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20, alignItems: 'center' }} onSubmit={handleSubmit}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Planta *</InputLabel>
          <Select
            name="idStation"
            value={idStation}
            onChange={e => handleInputOnChange(e)}
            label="Planta *"
            disabled={deleteMode || ( !deleteMode && !addMode ) || (stationSelected?.id && !contractSelected?.idStation)}
          > 
            { stationsList.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>) }
          </Select>
        </FormControl>
        <TextField fullWidth type="text" label="Nombre *" name="name" value={name} disabled={deleteMode} onChange={handleInputOnChange} variant="outlined" />
        <FormControl fullWidth style={{marginTop: 40, width: "98%"}} variant="outlined" onKeyDown={(e) => {e.preventDefault()}}>
          <InputLabel style={{marginTop: -38}} disabled={deleteMode}>Fecha de inicio *</InputLabel>
          {
            !deleteMode ? (
                <Datetime
                  name="startDate"
                  dateFormat="YYYY-MM-DD"
                  value={startDate} 
                  onChange={(e) => {
                    setStartDate(dayjs(e._d).format("YYYY-MM-DD HH:mm:ss"))
                  }}
                  timeFormat="HH:mm:ss"
                />
            ) : <Typography style={{color: "lightgray"}}>{startDate}</Typography>
          }
        </FormControl>
        <FormControl  style={{marginTop: 40, width: "98%"}} variant="outlined" onKeyDown={(e) => {e.preventDefault()}}>
          <InputLabel style={{marginTop: -38}} disabled={deleteMode}>Fecha de expiración *</InputLabel>
          {
            !deleteMode ? (
                <Datetime
                  name="endDate"
                  dateFormat="YYYY-MM-DD"
                  value={endDate} 
                  onChange={(e) => {
                    setEndDate(dayjs(e._d).format("YYYY-MM-DD HH:mm:ss"))
                  }}
                  timeFormat="HH:mm:ss"
                />
            ) : <Typography style={{color: "lightgray"}}>{endDate}</Typography>
          }
        </FormControl>
        <FormControl fullWidth style={{marginTop: 14}} variant="outlined">
          <InputLabel>Periodo de Pago *</InputLabel>
          <Select
            name="periodCalc"
            value={periodCalc}
            onChange={e => handleInputOnChange(e)}
            label="Periodo de Pago *"
            disabled={deleteMode}
          > 
            { prePayrollBasePaymentPeriods.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>) }
          </Select>
        </FormControl>
        <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '98%'}}>
          <Typography style={{ alignSelf: 'center' }}>Agregar Variantes de Contrato</Typography>
          <RegularButton disabled={!newVariants} round justIcon color="info" style={{ margin: 10 }} onClick={() => setVariants([...variants, {id: generateRandomID(32), name: "Nueva Variante", isComplete: 'bad'}])}>
            <AddIcon style={{ margin: 0 }}/>
          </RegularButton>
        </Box>
          {
            idStation &&
            variants.map(variant => (
              <Box key={variant.id} style={{marginTop: 10, width: '100%'}}>
                <ContractVariantAccordion 
                  key={variant.id}
                  periodCalc={periodCalc} 
                  setNewVariants={setNewVariants} 
                  setVariants={setVariants} 
                  variant={variant} 
                  variants={variants}
                  idStation={idStation}
                />
              </Box>
            )) 
          }
        <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '100%'}}>
          <RegularButton variant="contained" color="danger" onClick={handleClose}>Cancelar</RegularButton>
          <RegularButton 
            variant="contained" 
            color="facebook"
            style={{backgroundColor: blue, color: 'white'}} 
            onClick={handleSubmit}
            disabled={variants.filter(variant => variant.isComplete === 'bad').length
              || !(name && startDate && endDate && idStation && periodCalc)}
          >
            { 
              addMode 
                ? 'Agregar' 
                : deleteMode ? 'Eliminar' 
                : 'Guardar'
            }
          </RegularButton>
        </Box>
      </FormControl>
    </>
  )
}
